import React from "react";
import { useTranslation } from "react-i18next";
import { IconArrowUpRight } from "@tabler/icons-react";
import styles from "./VitalsBanner.module.css";

interface VitalsBannerProps {
  onClick?: () => void;
  className?: string;
}

const VitalsBanner: React.FC<VitalsBannerProps> = ({
  onClick,
  className = "",
}) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      className={`${styles.banner} ${className}`}
      onClick={onClick}
    >
      <span className={styles.bannerLeft}>
        <span className={styles.bannerNew}>{t("common.new")}</span>
        <span className={styles.bannerText}>
          {t("vitalsTracker.bannerTitle")}
        </span>
      </span>
      <span className={styles.bannerArrow}>
        <IconArrowUpRight size={15} stroke={2} />
      </span>
    </button>
  );
};

export default VitalsBanner;
